export const firebaseConfig = {
    apiKey: "AIzaSyA_vqgkiDd9z_98yum0pv8WLoJMxphv5PU",
    authDomain: "coin-calculator-75ff3.firebaseapp.com",
    databaseURL: "https://coin-calculator-75ff3.firebaseio.com",
    projectId: "coin-calculator-75ff3",
    storageBucket: "coin-calculator-75ff3.appspot.com",
    messagingSenderId: "825167081174",
    appId: "1:825167081174:web:8a8d3dea46c10e9fb2a377",
    measurementId: "G-8NFH0X8YT9"
  };